import type { Cluster, ClusterRun } from '../../types/apiModels'
import { apiClient } from './client'
import endpoints from './endpoints'
import type { PaginationParams } from './types'
import { unwrapPaginated, type Paginated } from './normalize'

const DEFAULT_PAGE_SIZE = 100

export type ClusterMeta = {
  latestRun: ClusterRun | null
}

type GetFarmClustersArgs = {
  farmId: string
  query?: PaginationParams<Cluster>
  signal?: AbortSignal
}

export const getFarmClustersWithMeta = async ({
  farmId,
  query,
  signal,
}: GetFarmClustersArgs): Promise<Paginated<Cluster, ClusterMeta>> => {
  const response = await apiClient.get(endpoints.v2.farms.clusters(farmId), {
    params: { size: DEFAULT_PAGE_SIZE, ...query },
    signal,
  })
  return unwrapPaginated<Cluster, ClusterMeta>(response)
}
